export default __webpack_public_path__ + "static/media/argentBankLogo.e031a16c.png";